module.exports = {
    substitution: function(str, args) {
        if (args instanceof Array) {
            for (var i = 0, j = args.length; i < j; i++) {
                // disable the special replacement patterns
                var escapedArg = args[i].toString().replace(new RegExp('\\$', 'g'), '$$$$');
                var pattern = new RegExp('\\{' + i + '\\}', 'g');
                str = str.replace(pattern, escapedArg);
            }
        } else {
            // disable the special replacement patterns
            var escapedArgs = args.toString().replace(new RegExp('\\$', 'g'), '$$$$');
            str = str.replace(/\{0\}/g, escapedArgs);
        }

        // Server-side passes parameterized strings through MessageFormat which
        // requires that the source use double-apostrophes to mean single apostrophe.
        // Client-side replacement doesn't have this restriction, so we remove them here.
        return str.replace(/''/g, "'");
    },
    splitSubstitution: function(str, args) {
        if (str === '') {
            return [''];
        }
        if (!Array.isArray(args)) {
            args = [args];
        }

        return str
            .split(/({\d+})/)
            .filter(function(part) {
                // If there is a match at the beginning or end of the string,
                // split adds an empty string to the array.
                // So filter out these empty strings.
                return part !== '';
            })
            .map(function(part) {
                // Check whether or not this part is an argument substitution string
                var match = part.match(/^{(\d+)}$/);
                if (match === null) {
                    return part;
                }

                var argumentIndex = parseInt(match[1], 10);
                if (argumentIndex >= args.length) {
                    return part;
                }

                return args[argumentIndex];
            });
    }
};
